import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Quill's default theme
import styles from "./TextEditorCart.module.css"; // Import CSS module for custom styles
import { CSSProperties, useEffect, useRef } from "react";
import "./global.css";
import { Label } from "@shopify/polaris";
import ShopifyNativeError from "../ShopifyNativeError/ShopifyNativeError";
import ShopifyNativeHelpText from "../ShopifyNativeHelpText/ShopifyNativeHelpText";
// import ReactDOM from "react-dom";
// import { EmojiMart } from "./EmojiMart";
type TextEditorProps = {
    value: string | undefined;
    onChange: any;
    placeholder?: string;
    className?: string; // Optional custom class for external styles
    readOnly?: boolean;
    error?: string | undefined;
    _style?: CSSProperties;
    toolBarIdentifier?: number;
    handleAlignment?: any;
    title?: null | string;
    submit?: any;
    helpText?: any;
};

const defaultToolbarOptions = [
    ["bold", "italic", "underline", "strike"], // Basic formatting
    [{ align: [] }],
    [{ size: ["small", false, "large", "huge"] }],
];

function handleLink(value: boolean) {
    if (value) {
        // @ts-expect-error required
        const range = this.quill.getSelection();
        if (range == null || range?.length == 0) return;
        // @ts-expect-error required
        let preview = this.quill.getText(range);
        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) {
            preview = "https:" + preview;
        }
        // @ts-expect-error required
        const tooltip = this.quill.theme.tooltip;
        tooltip.edit("link", preview);
    } else {
        // @ts-expect-error required
        this.quill.format("link", false);
    }
}

const TextEditorCart = ({
    value = "",
    onChange,
    placeholder = "Enter text...",
    className = "",
    readOnly = false,
    error = "",
    _style,
    toolBarIdentifier = 1,
    title = null,
    submit,
    helpText = "",
}: TextEditorProps) => {
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            // @ts-expect-error hack
            const quill = editorRef?.current?.getEditor();
            if (quill) {
                quill.root.setAttribute("spellcheck", "false"); // Disable spellcheck
            }
        }
    }, []);

    return (
        <>
            {title?.length && (
                <div style={{ marginBottom: -10 }}>
                    <Label id={"TextEditorCart"}>{title}</Label>
                </div>
            )}

            <div
                className={`${styles.textEditorWrapper} ${className}`}
                style={{ marginTop: 5, ..._style }}
                id={"ql" + toolBarIdentifier}
            >
                <ReactQuill
                    ref={editorRef}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    onBlur={submit && submit}
                    modules={{
                        toolbar: {
                            container: defaultToolbarOptions,
                            handlers: {
                                // emoji: handleEmoji,
                                link: handleLink,
                            },
                        },
                    }}
                    formats={[
                        "bold",
                        "italic",
                        "underline",
                        "strike",
                        "link",
                        "center",
                        "align",
                        "size",
                        // "emoji",
                    ]}
                    readOnly={readOnly}
                />
            </div>
            {!!helpText.length && <ShopifyNativeHelpText text={helpText} />}
            {!!error.length && <ShopifyNativeError error={error} />}
        </>
    );
};

export default TextEditorCart;
